import styled from 'styled-components';

export const ToggleWrapper = styled.div`
  cursor: pointer;
  transition: ${(props) => props.theme.constants.transitionBase};

  &.disabled {
    cursor: not-allowed;
  }

  .react-toggle .react-toggle-track {
    display: flex;
    background-color: #e6e9f2;
    height: 16px;
    width: 46px;
  }

  .react-toggle {
    &:hover {
      .react-toggle-track {
        background-color: #e6e9f2;
      }
    }

    //? focus style
    /*
    &:has(:focus-visible) {
      outline: 2px solid ${({ theme }) => theme.colors.focusRing};
      outline-offset: 4px;
      border-radius: 4px;
    }
    */

    .react-toggle-thumb {
      width: 22px;
      height: 22px;
      border: 2px solid white;
      top: -3px;
      left: 0;
      box-shadow: none !important;
      background-color: #515151;

      &:before,
      &:after {
        content: '';
        position: absolute;
        width: 9px;
        height: 1.2px;
        background-color: white;
        border-radius: 2px;
        top: 8.5px;
      }

      &:before {
        -webkit-transform: rotate(45deg);
        -moz-transform: rotate(45deg);
        transform: rotate(45deg);
        left: 4.5px;
      }
      &:after {
        -webkit-transform: rotate(-45deg);
        -moz-transform: rotate(-45deg);
        transform: rotate(-45deg);
        left: 4.5px;
      }
    }

    &.react-toggle--checked {
      .react-toggle-thumb {
        left: 28px;
        background-color: ${({ theme }) => theme.colors.link};

        &::before {
          display: none;
        }
        &::after {
          content: 'L';
          display: inline-block;
          font-family: ${({ theme }) => theme.fontset.titillium};
          -ms-transform: scaleX(-1) rotate(-45deg); /* IE 9 */
          -webkit-transform: scaleX(-1) rotate(-45deg); /* Chrome, Safari, Opera */
          transform: scaleX(-1) rotate(-45deg);
          position: absolute;
          top: 1px;
          left: 10px;
          right: unset;
          font-size: 12px;
          color: white;
          height: 0;
        }
      }
    }
  }
`;
